import React, { useState } from 'react';
import Modal from '@hubins/components/Modal';
import Input from '@hubins/components/Input';
import Button, { ButtonWrap } from '@hubins/components/Button';
import ErrorMessage from 'components/ErrorMessage';
import { useMiddleman } from '@hubins/middleman';
import { Document } from './index';

type Props = {
  document: Document;
  setDocument: React.Dispatch<React.SetStateAction<Document | null>>;
  refetch: () => void;
}

const EditDocumentModal = ({ document, setDocument, refetch }: Props) => {
  const middleman = useMiddleman();


  const [fileName, setFileName] = useState<any>(document?.name);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await middleman.promisePut(document.editLink, {
        name: fileName
      });
      setDocument(null);
      refetch();
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  return (
    <Modal
      open={!!document}
      callback={setDocument}
      shouldCloseOnOverlayClick
      closeButton
    >
      <form onSubmit={handleSave} className="s-top-l">
      <Input
        label="Name"
        value={fileName}
        callback={setFileName}
        controlled
      />
      <ButtonWrap>
        <Button className="cta" iconColor="white" type="submit" loading={loading}>Save</Button>
        <Button onClick={() => setDocument(null)}>Cancel</Button>
      </ButtonWrap>
      </form>
      <ErrorMessage text={error} showError={!!error} />
    </Modal>
  );
};

export default EditDocumentModal;